import { MapUtils } from '../../utility/map-utils.js';
import {
  DataModel,
  DataModelBuilder,
  SerializationContext,
  SerializedData,
  cloneMap,
  isSameData,
  isSameMap,
  mapToData,
} from '../dto/dto.js';
import { PromoterEventStats } from './promoter-event-stats.js';

export class PromoterStats extends DataModel {
  static readonly TYPE_ID: string = 'fa367abd0e9f48c589c2511ce45031b4';

  // Promoter statistics per event.
  constructor(
        public readonly eventStats: Map<string, PromoterEventStats>,
  ) {
    super();
  }

  get $typeId(): string {
    return PromoterStats.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PromoterStats {
    return new PromoterStats(
        MapUtils.getMap(map, 'eventStats', (k, v) => ({
          key: k,
          value: context.fromData<PromoterEventStats>(v as SerializedData),
        })),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'eventStats': mapToData(this.eventStats, (k, v) => ({
        key: k,
        value: context.toData(v),
      })),
    };
  }

  clone(): this {
    return new PromoterStats(
        cloneMap(this.eventStats, (v) => v.clone()),
    ) as this;
  }

  isSame(other: PromoterStats): boolean {
    if(this === other) {
      return true;
    }

    return isSameMap<string, PromoterEventStats>(other.eventStats, this.eventStats, (lh, rh) => isSameData(lh, rh));
  }
}

export class PromoterStatsBuilder extends DataModelBuilder<PromoterStats> {
  build(context: SerializationContext, map: SerializedData): PromoterStats {
    return PromoterStats.fromMap(context, map);
  }
}
